export class UnreachableI18nCaseError extends Error {
  constructor(value) {
    super(`I18n value for ${value} not found`);
  }
}
export const getTypeAction = (approvalType, approvalAction) => {
  return `${approvalType}-${approvalAction}`;
};